import { useEffect } from 'react';

export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `Forefront Track - ${title}`;
  }, [title]);

  return null;
};
